<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Send Password Reset Link </h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Email</label>
                      <div class="form-group">
                        <label>Username or email</label>
                        <input
                          id="email"
                          type="email"
                          name="email"
                          v-model.trim="$v.email.$model"
                          :class="{ 'is-invalid': validationStatus($v.email) }"
                          class="form-control"
                        />
                        <div v-if="!$v.email.required" class="invalid-feedback">
                          The email field is required.
                        </div>
                        <div v-if="!$v.email.email" class="invalid-feedback">
                          The email is not valid.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-4">
                  <div class="col-sm-12 pl-0 mt-10">
                    <input
                      type="submit"
                      class="btn btn-primary"
                      value="Submit"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>
export default {};
</script>
<script>
import {
  required,
  email,
} from "vuelidate/lib/validators";
import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import firebase from "firebase";
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { db } from '../../main'

export default {
  name: "Login",
   components:{
        'Header':Header,
        'Sidebar':Sidebar,
        'Footer':Footer,

    },
  data: function() {
    return {
      email: "",
      password: "",
 passworddate: "",
otp: "",
      error: "",
 dd: "",
 d: "",
 mm:"",
 yyyy:"",
 name:"",
	passwordupdatedate:"",
 uid:"",
a:""
    };
  },
  validations: {
    email: { required, email },
  },
  methods: {
    validationStatus: function(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    submit: function() {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
          console.log("ggg");
          //this.$router.replace({ name: "Dashboard" });
          //console.log(data.user.uid);
          //console.log('ggg');
          //var id  = "sOFktZbVwCze7nzGiOek";

          db.collection("users")
            .where("email", "==", this.email)
            .get()
            .then((querySnapshot) => {
 //console.log(querySnapshot.size);
if(querySnapshot.size == 1){
        querySnapshot.forEach((doc) => {
                console.log(doc.id, " => ", doc.data());
				//console.log(doc.data().size)
				this.passworddate = doc.data().email;
				this.uid = doc.data().user_id;
				this.name = doc.data().firstname;
				this.otp = Math.floor(100000 + Math.random() * 900000);
				this.today  = new Date();
				this.a = 1;
				this.d = String(this.today.getDate()).padStart(2, '0');
				this.dd = parseInt(this.d) + parseInt(this.a);
				this.mm = String(this.today.getMonth() + 1).padStart(2, '0'); //January is 0!
				this.yyyy = this.today.getFullYear();
				this.passwordupdatedate = this.mm + '/' + this.dd + '/' + this.yyyy;
				
				/* update user table */
               firebase.auth().sendPasswordResetEmail(this.email);
			
 this.$toasted.success('Success, Please Check Your Email For Reset Password !', {
									icon : 'check',						 })
				/*End update user table */
				
              });	  }else{	    this.$toasted.error('Error, Email not Exist!', {
                  icon : 'check',
                   //icon : 'error_outline'
               })
  }
            })
            .catch((error) => {
              console.log("Error getting documents: ", error);
			
            });
			
    
    },
  },
};
</script>
